module.exports = __webpack_public_path__ + "b94d8470be851177379e17183e419c50.jpg";